import styled from 'styled-components'
import { belowTablet, fromTablet } from 'utilities/styled'
import StatusLabelBase from 'components/status-label'
import Paragraph, { captionCss, captionSmallCss } from 'components/typography/paragraph'
import PersonBase from 'components/person'

export const LogEntry = styled.li`
    display: grid;
    grid-template-columns: 20px minmax(0, 1fr) var(--timestamp-width, 8ch);
    gap: 24px;

    padding-block: 16px;

    &:not(:last-child) {
        border-bottom: 1px solid var(--huma-color-border-default);
    }

    ${belowTablet`
        grid-template-columns: 20px minmax(0, 1fr);
    `}
`

export const AvatarWrapper = styled.div`
    height: 24px;
    padding-block: 2px;
`

export const Content = styled.div``

export const ContentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 8px 16px;

    ${belowTablet`
        display: grid;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr var(--timestamp-width, 8ch);
    `}
`

export const StatusLabel = styled(StatusLabelBase)`
    ${belowTablet`
        grid-row: 2;
        justify-self: start;
    `}
`

export const ContentHeaderTitle = styled(Paragraph)`
    padding-block: 2px; /* Center within the first line */

    font-family: var(--huma-font-monospace);
    font-size: 14px;
    line-height: 20px;
`

export const Person = styled(PersonBase)`
    padding-block-start: 4px;
`

export const ContentBody = styled.div`
    margin-block: 8px;

    h3 {
        ${captionCss}
    }

    & > :last-child {
        margin-bottom: 0;
    }
`

export const Timestamp = styled.time`
    ${captionSmallCss}
    font-family: var(--huma-font-monospace);

    font-size: 14px;
    line-height: 20px;
    text-align: end;

    ${Content} + & {
        ${belowTablet`
            display: none;
        `}
    }

    ${ContentHeader} & {
        ${fromTablet`
            display: none;
        `}
    }
`
